import useFetchRecordTypes from '../useFetchRecordTypes';
import useFetchProviders from '../useFetchProviders';
import useAssociationForm from '../addLocation/useAssociationForm';

export default function useAddAssociations() {
  const { recordTypes } = useFetchRecordTypes();
  const { providers } = useFetchProviders();
  const { associationsForm } = useAssociationForm();

  return {
    associationsForm,
    recordTypes,
    providers,
  };
}
